import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import {slider1,slider2,slider3,slider4,slider5,slider6,slider7,slider8,upimg3} from "../../assets/img";

function DryCleaning () {

return (
    <>
        <div className="container">
            <div className="row">
                <div className="col-md-12">                    
                    <div className="slider-up">
                    <Swiper
                        spaceBetween={15}
                        navigation={true}
                        modules={[Navigation]}
                        className="slider-up-slider"
                        >                                                                                  
                            
                            <SwiperSlide >                            
                                <img src={slider4} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>
                            <SwiperSlide >                            
                                <img src={slider5} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>
                            <SwiperSlide >                            
                                <img src={slider6} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>
                            <SwiperSlide >                            
                                <img src={slider7} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>                            
                            <SwiperSlide >                            
                                <img src={slider8} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>
                            <SwiperSlide >                            
                                <img src={slider1} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>
                            <SwiperSlide >                            
                                <img src={slider2} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide> 
                            <SwiperSlide >                            
                                <img src={slider3} alt="Hero Image" className="img-fluid" />
                            </SwiperSlide>
                      </Swiper>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">   
                    <div className="up-content">
                        <h2 className="up-h2">DRY CLEANING</h2>
                        <p>At Uplands Laundrette skilled staff combined with the latest cleaning & finishing technology offers a service that is fast and professional dealing with every garment individually.</p>
                        <p>We are experts in dealing with all types of fabrics, from business wear to designer outfits and wedding dresses.</p>
                        <p>Garments are pressed and hand finished with special finishing equipment.</p>
                        <p>We pride ourselves on the quality of our cleaning and have many happy customers who return time after time for a fast, efficient & friendly service.</p>
                        <p>As well as offering Dry Cleaning, we offer a more cost effective alternative, Steam Pressure Cleaning (SPC) for all your traditional dry cleaning requirements.</p>
                        <h4>Price List</h4>
                        <b className="up-sub-head">Suit Dry Cleaning</b>
                        <p>Two piece suit from £15.95</p>
                        <p>Three piece suit from £16.95</p>
                        <b className="up-sub-head"><br /></b>
                        <p>Trousers from £7.95</p>
                        <p>Skirt from £7.95</p>
                        <p>Jackets from £10.5</p>
                        <p>Coats from £12.95</p>
                        <p>Shirts from £2.95</p>
                        <p>Jumper Lightweight from £7.00</p>
                        <p>Evening Top from £5.95</p>
                        <p>Silk Evening Top from £5.95</p>
                        <p>Bustier Top from £5.95</p>
                        <p>Silk Bustier Top from £5.95</p>
                        <p>Silk Shirt from £5.95</p>
                        <b className="up-sub-head">Throwovers</b>
                        <p>Single £14.95</p>
                        <p>Double £17.5</p>
                        <b className="up-sub-head">Dresses</b>
                        <p>Day Dresses £14.95</p>
                        <p>Silk Day Dresses £17.5</p>
                        <p>Plain Evening Dresses £15.5</p>
                        <p>Silk Evening Dresses £18.5</p>
                        <p>Elaborate Evening Dresses £19.95</p>
                        <p>Long Evening Dress £15.9</p>
                        <p>Prom Dress £28</p>
                        <p>Ball Gown £29</p>
                        <b className="up-sub-head">Wedding Items</b>
                        <p>Wedding Dress from Boxed £150.00</p>
                        <p>Bridemaids from £19.5</p>
                        <p>Flower Girl £21.00</p>
                        <p>Silk Wedding Dress from £25.00</p>
                        <b className="up-sub-head">Accessories</b>
                        <p>Tie £3.95</p>
                        <p>Scarf £5.95</p>
                        <p>Pashmina £7.9</p>
                        <p>Wrap £7.9</p>
                        <p>Hats £7.00</p>
                        <p>Dressing Gown £7.5</p>
                        <p>Waistcoats £5.00</p>
                        <p>Silk Waistcoats £5.95</p>
                        <b className="up-sub-head">Duvet Cleaning</b>
                        <p>Single £14.95*</p>
                        <p>Double £16.95*</p>
                        <p>King Size £18.95*</p>
                        <p>Single Blanket £14.9</p>
                        <p>Double Blanket £19.00</p>
                        <p>* Additional £6.00 charge for each feather.</p>
                        <b className="up-sub-head">Sleeping Bags</b>
                        <p>Single £14.95</p>
                        <p>Double £16.95</p>
                        <p>Child's Size £14.5</p>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="up-img">
                        <img src={upimg3} alt="" />
                    </div>
                    <div className="up-card-bg">
                        <p>Book a Pickup - Call 01792 644238 or<br/> text 07999 999294</p>
                    </div>
                </div>
            </div>
        </div>
    </>
)
}
export default DryCleaning;